import { CMSApi } from 'api';
import { ThunkDispatch } from 'redux-thunk';
import { AppTheme } from 'shared/constants/common';
import { Action, unreadMessageState } from 'shared/interface';
import * as actionTypes from 'shared/store/action-types';
import { createAction, setTheme } from 'shared/util/utility';
import { reactNativeEvent } from '../react-native/event';

const handleAppTheme = (appTheme: AppTheme) => {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	return async (dispatch: ThunkDispatch<Record<string, unknown>, Record<string, unknown>, Action>) => {
		dispatch(createAction(actionTypes.APP_THEME, appTheme));
		reactNativeEvent().send('THEME', { theme: appTheme });
		setTheme(appTheme);
	};
};

const getUnreadMessage = () => {
	return async (dispatch: ThunkDispatch<{}, {}, Action>) => {
		try {
			const response = await CMSApi.getUnreadMessageCount();
			const unreadMessages: unreadMessageState = {
				lastMessageTitle: response.data.data.lastMessageTitle,
				messageCount: response.data.data.messagesCount,
				lastMessageDate: response.data.data.lastMessageDate,
				lastMessageId: response.data.data.lastMessageId,
			};

			dispatch(createAction(actionTypes.UNREAD_MESSAGE_SUCCESS, { unreadMessages }));
		} catch (err) {
			console.error(err);
		}
	};
};

const setEventPopup = (isEventPopup: boolean) => {
	return async (dispatch: ThunkDispatch<{}, {}, Action>) => {
		dispatch(
			createAction(actionTypes.SET_ARROW_STATE, {
				isArrow: isEventPopup,
			}),
		);
	};
};

export { handleAppTheme, getUnreadMessage, setEventPopup };
